<template>
  <app-layout>

    <!-- Page header -->
    <div>
      <div class="px-4 sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-8">
        <div class="py-6 md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <!-- Profile -->
            <div class="flex items-center">
              <img class="hidden h-16 w-16 rounded-full sm:block"
                   :src="$page.props.user.profile_photo_path"
                   alt=""/>
              <div>
                <div class="flex items-center">
                  <img class="h-16 w-16 rounded-full sm:hidden"
                       :src="$page.props.user.profile_photo_path"
                       alt=""/>
                  <h1 class="ml-3 text-2xl font-bold leading-7 text-gray-900 sm:leading-9 sm:truncate">
                    Hello, {{ this.$page.props.user.name }}
                  </h1>
                </div>
                <dl class="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                  <!--                  <dd class="flex items-center text-sm text-gray-500 font-medium capitalize sm:mr-6">-->
                  <!--                    <IdentificationIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true"/>-->
                  <!--                    <span class="text-sm text-red-400 font-bold">Trail ends in 7 days</span>-->
                  <!--                  </dd>-->
                  <dt class="sr-only">Account status</dt>
                  <dd class="mt-3 flex items-center text-sm text-gray-500 font-medium sm:mr-6 sm:mt-0 capitalize">

                    <template v-if=" $page.props.user.email_verified_at === null">
                      <XCircleIcon
                          class="inline-flex items-center mr-1.5 h-5 w-5 text-red-400" aria-hidden="true"/>
                      <label class="font-bold"> Unverified account</label>
                    </template>
                    <template v-else>
                      <CheckCircleIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400" aria-hidden="true"/>
                      <label class="font-bold">Verified account</label>
                    </template>

                    <template v-if=" $page.props.user.is_vip === true">
                      <StarIcon
                          class="ml-2 inline-flex items-center mr-1.5 h-5 w-5 text-yellow-400" aria-hidden="true"/>
                      <label class="font-bold">VIP</label>
                    </template>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <!--          <div class="mt-6 flex space-x-3 md:mt-0 md:ml-4">-->
          <!--            <button-->
          <!--                class="inline-flex items-center justify-center px-4 py-1 space-x-1 bg-red-500 text-white rounded-md shadow animate-bounce hover:bg-red-600"-->
          <!--            >-->
          <!--              <span class="font-bold">Upgrade your account today</span>-->
          <!--            </button>-->
          <!--          </div>-->
        </div>
      </div>
    </div>

    <hr>
    <div class="mt-8">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="text-lg leading-6 font-bold text-gray-900">Our Apps</h2>
        <div class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
          <div class="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            <!-- Card -->
            <div class="flex justify-center font-semibold" @mouseover="showText('Retrospective')"
                 @click="this.$inertia.visit(route('retro.public.board.list'))"
                 @mouseleave="showText('')">

              <div class="flex flex-col">
                <div class="h-32 w-32 relative cursor-pointer mb-5">
                  <div class="absolute inset-0 bg-white opacity-25 rounded-lg shadow-2xl"></div>
                  <div class="absolute inset-0 transform  hover:scale-75 transition duration-300">
                    <div class="h-full w-full bg-white rounded-lg shadow-2xl"><img src="/images/retro.svg"
                                                                                   class="ml-4"/>
                    </div>
                  </div>
                </div>
                <div class="text-bold text-black text-xl">
                  Retrospective
                </div>
              </div>

            </div>

            <div class="flex justify-center font-semibold" @mouseover="showText('Planning Poker')"
                 @mouseleave="showText('')"
                 @click="this.$inertia.visit(route('planning-rooms.public-rooms'))"
            >
              <div class="flex flex-col">
                <div class="h-32 w-32 relative cursor-pointer mb-5">
                  <div class="absolute inset-0 bg-white opacity-25 rounded-lg shadow-2xl"></div>
                  <div class="absolute inset-0 transform  hover:rotate-45 transition duration-300">
                    <div class="h-full w-full bg-white rounded-lg shadow-2xl"><img src="/images/poker.svg"/></div>
                  </div>
                </div>
                <div class="text-bold text-black text-xl">
                  Planning Poker
                </div>
              </div>
            </div>
            <div class="flex justify-center font-semibold" @mouseover="showText('Async Report')"
                 @click="this.$inertia.visit(route('report.public.reports'))"
                 @mouseleave="showText('')">
              <!-- rotate -->
              <div class="flex flex-col">
                <div class="h-32 w-32 relative cursor-pointer mb-5">
                  <div class="absolute inset-0 bg-white opacity-25 rounded-lg shadow-2xl"></div>
                  <div class="absolute inset-0 transform hover:-translate-x-10 transition duration-300">
                    <div class="h-full w-full bg-white rounded-lg shadow-2xl"><img src="/images/report.svg"/></div>
                  </div>
                </div>
                <div class="text-bold text-black text-xl">
                  Async Report
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="mt-8">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="text-lg leading-6 font-bold text-gray-900">Helpful Links</h2>
        <div class="mt-12">
          <div class="relative">
            <div class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">

              <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                <div v-for="feature in features" :key="feature.name" class="pt-6">
                  <div class="flow-root bg-gray-50 rounded-lg px-6 pb-8">
                    <div class="-mt-6">
                      <div>
                  <span class="inline-flex items-center justify-center p-3 bg-blue-500 rounded-md shadow-lg">
                    <component :is="feature.icon" class="h-6 w-6 text-white" aria-hidden="true"/>
                  </span>
                      </div>
                      <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">{{ feature.name }}</h3>
                      <p class="mt-5 text-base text-gray-500">
                        {{ feature.desc }}
                      </p>
                    </div>
                    <a class="mt-2 text-sm font-medium text-blue-600 lg:mt-4" :href="feature.href">Learn more <span
                        aria-hidden="true">&rarr;</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!--    <div class=" min-h-screen ">-->


    <!--      <h1 class="text-transparent bg-clip-text bg-gradient-to-br from-black to-gray-500 py-40 flex justify-center text-5xl font-bold ">-->

    <!--        Hello, G'day, {{ this.$page.props.user.name }}-->
    <!--      </h1>-->


    <!--      <div class="sm:px-20 md:px-40 sm:py-auto w-50 lg:px-40 lg:py-50 flex items-center justify-between">-->
    <!--        <div class="flex" @mouseover="showText('Retrospective')" @click="this.$inertia.visit(route('retrospective'))"-->
    <!--             @mouseleave="showText('')">-->

    <!--          <div class="flex flex-col">-->
    <!--            <div class="h-32 w-32 relative cursor-pointer mb-5">-->
    <!--              <div class="absolute inset-0 bg-white opacity-25 rounded-lg shadow-2xl"></div>-->
    <!--              <div class="absolute inset-0 transform  hover:scale-75 transition duration-300">-->
    <!--                <div class="h-full w-full bg-white rounded-lg shadow-2xl"><img src="/images/retro.svg" class="ml-4"/>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="text-bold text-black text-xl">-->
    <!--              Retrospective-->
    <!--            </div>-->
    <!--          </div>-->

    <!--        </div>-->

    <!--        <div class="flex" @mouseover="showText('Planning Poker')" @click="this.$inertia.visit(route('planning-poker'))"-->
    <!--             @mouseleave="showText('')">-->
    <!--          <div class="flex flex-col">-->
    <!--            <div class="h-32 w-32 relative cursor-pointer mb-5">-->
    <!--              <div class="absolute inset-0 bg-white opacity-25 rounded-lg shadow-2xl"></div>-->
    <!--              <div class="absolute inset-0 transform  hover:rotate-45 transition duration-300">-->
    <!--                <div class="h-full w-full bg-white rounded-lg shadow-2xl"><img src="/images/poker.svg"/></div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="text-bold text-black text-xl">-->
    <!--              Planning Poker-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="flex" @mouseover="showText('Async Report')" @click="this.$inertia.visit(route('stand-up.index'))"-->
    <!--             @mouseleave="showText('')">-->
    <!--          &lt;!&ndash; rotate &ndash;&gt;-->
    <!--          <div class="flex flex-col">-->
    <!--            <div class="h-32 w-32 relative cursor-pointer mb-5">-->
    <!--              <div class="absolute inset-0 bg-white opacity-25 rounded-lg shadow-2xl"></div>-->
    <!--              <div class="absolute inset-0 transform hover:-translate-x-10 transition duration-300">-->
    <!--                <div class="h-full w-full bg-white rounded-lg shadow-2xl"><img src="/images/report.svg"/></div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="text-bold text-black text-xl">-->
    <!--              Async Report-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->


    <!--    </div>-->


  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import Welcome from '@/Jetstream/Welcome'
import {
  ChevronRightIcon,
  XCircleIcon,
  StarIcon,
  CheckCircleIcon,
  IdentificationIcon,
  LightBulbIcon
} from '@heroicons/vue/solid'
import SignInWithSlackButton from "@/Components/SocialButton/SignInWithSlackButton";
import AddToSlackButton from "@/Components/SocialButton/AddToSlackButton";
import {ref} from "vue";

const stats = [
  {name: 'Planning Poker Rooms Usage', stat: '3/10'},
  {name: 'Slack Reports Usage', stat: '7/10'},
  {name: 'Retro Rooms Usage', stat: '1/20'},
]

const features = [
  {name: 'Retrospective Usage', href: '/landing/retro', icon: LightBulbIcon},
  {name: 'Planning Poker Usage', href: '/landing/poker', icon: LightBulbIcon},
  {name: 'Slack Report Usage', href: '/landing/report', icon: LightBulbIcon},
  {name: 'Terms and Conditions', href: '/terms-of-service', icon: LightBulbIcon},
  {name: 'Privacy', href: '/privacy-policy', icon: LightBulbIcon},
  {name: 'Contact Us', href: '/landing/contact', icon: LightBulbIcon},
]
export default {
  setup() {
    const text = ref(null);

    const showText = (value) => {
      text.value = value;
    }
    return {
      features,
      showText,
      stats,
      text
    }
  },
  mounted() {
  },
  data() {
    return {}
  },
  components: {
    XCircleIcon,
    IdentificationIcon,
    CheckCircleIcon,
    AddToSlackButton,
    SignInWithSlackButton,
    AppLayout,
    Welcome,
    ChevronRightIcon, StarIcon
  },
}
</script>
